// extracted by mini-css-extract-plugin
module.exports = {"p11dTable":"P11dListTab_p11dTable__3eV4C"};